export default "__VITE_ASSET__BSXbzXIS__"